import React, { useState, useEffect } from 'react';
import TabPage from 'components/common/TabPage';
import { Spinner, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
// import { paymentDetailsAction, paymentErrorAction, paymentHeaderAction } from 'actions';
import { toast } from 'react-toastify';
import loader from '../../assets/img/loader.svg'
const tabArray = ['Client SOA'];

const ClientSOA = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');

  const formChangedReducer = useSelector((state) => state.rootReducer.formChangedReducer)
  var formChangedData = formChangedReducer.formChanged;

  let isFormChanged = Object.values(formChangedData).some(value => value === true);



  useEffect(() => {
    $('#btnSave').hide();
    $("#btnNew").hide();
  }, []);

  $('[data-rr-ui-event-key*="Payment"]').off('click').on('click', function () {
    $("#btnSave").show();
    $('#btnSave').attr('disabled', true);
    $("#btnNew").hide();
  })

  const exitModule = () => {
    $('#btnExit').attr('isExit', 'true');
    if (isFormChanged) {
      setModalShow(true)
    } else {
      window.location.href = '/dashboard';
    }
  }

  const discardChanges = () => {
    $('#btnDiscard').attr('isDiscard', 'true');
    if ($('#btnExit').attr('isExit') == 'true') {
      window.location.href = '/dashboard';
    }
    setModalShow(false);
  }

  const handleSave = async () => {
    // for (let i = 0; i < paymentDetails.length; i++) {
    //   const paymentDetailData = paymentDetails[i];
    //   const hasEncryptedPaymentDetailCode = paymentDetailData.encryptedPaymentDetailCode !== '';
    //   if (hasEncryptedPaymentDetailCode) {
    //     await updatePaymentDetail(paymentDetailData, i);
    //   } else if (paymentDetailData.paidAmount > 0 && paymentDetailData.encryptedPaymentDetailCode == '') {
    //     await addPaymentDetail(paymentDetailData, i);
    //   }
    // }
    // if (parseFloat(paymentHeaderDetails.invoiceAmount) == parseFloat(paymentHeaderDetails.invoicePaidAmount)) {
    //   const updatedPaymentDetails = paymentDetails.map(detail => {
    //     let status = ""
    //     if (parseFloat(detail.productGrandAmt) == parseFloat(detail.paidAmount)) {
    //       status = "Fully Paid"
    //     }
    //     else {
    //       status = "Partially Paid"
    //     }
    //     return {
    //       ...detail,
    //       status: status
    //     };
    //   });
    //   dispatch(paymentDetailsAction(updatedPaymentDetails))
    // }
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {modalShow &&
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to save changes?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={handleSave}>Save</Button>
            <Button variant="danger" id="btnDiscard" onClick={() => discardChanges()}>Discard</Button>
          </Modal.Footer>
        </Modal>
      }
      <TabPage
        tabArray={tabArray}
        module='ClientSOA'
        saveDetails={handleSave}
        exitModule={exitModule}
      />
    </>
  )
}

export default ClientSOA